export enum MissionGroupStatusEnum {
    IN_PROGRESS = 'IN_PROGRESS',
    AVAILABLE = 'AVAILABLE',
    CONFIRMED = 'CONFIRMED',
    WAITING = 'WAITING',
    CANCELLED = 'CANCELLED',
    IGNORED = 'IGNORED',
}
